import { createRefreshSafety, createClientCompatibility } from '@speaking-coach/ui'

export const appRefreshSafety = createRefreshSafety()

export const appCompatibility = createClientCompatibility()
